import Vue from 'vue';
import isEmail from 'validator/lib/isEmail';
import isEmpty from 'validator/lib/isEmpty';
import matches from 'validator/lib/matches';
import { hasValidMobilePhoneNumber, isString, ssnPattern } from '@/validators';

export default Vue.extend({
  computed: {
    rules(): Record<string, Function> {
      const t = this.$t.bind(this);
      return {
        required: (v: any) => !!v || t('validation.required'),
        requiredField: (label: string) => (v: any) => !!v || t('validation.requiredField', { property: label }),
        requiredCheck: (label: string) => (v: any) => !!v || t('validation.requiredCheck', { property: label }),
        requiredSelection: (label: string) => (v: any) => !!v || t('validation.requiredSelection', { property: label }),
        pep: (v: any) => !v && v != null || t('validation.pep'),
        isNotEmpty: (v: any) => (isString(v) && !isEmpty(v, { ignore_whitespace: true })) || t('validation.required'),
        email: (v: any) => !v || isEmail(v) || t('validation.email'),
        // NOTE: This is a swedish social security number check, need to adjust if used in other localizations
        pid: (v: any) => !isString(v) || matches(v, ssnPattern) || t('validation.pid'),
        pidEmpty: (v: any) => !isString(v) || v === '' || matches(v, ssnPattern) || t('validation.pid'),
        mobilePhoneNumber: (v: any) => !v || hasValidMobilePhoneNumber(v) || t('validation.mobileNumber'),
        tristateBooleanRequired: (v: any) => v !== null && v !== undefined || t('validation.required'),
      };
    },
  },
});
